export default __webpack_public_path__ + "static/media/icon_notes.a38247ce.svg";